import { logEvent as firebaseLogEvent } from "firebase/analytics";
import { analytics } from "./firebase";

interface EventParams {
  [key: string]: any;
}

/**
 * Logs a custom analytics event.
 * @param eventName - The name of the event.
 * @param eventParams - An object of key-value pairs to associate with the event.
 */
export const logEvent = (eventName: string, eventParams?: EventParams) => {
  // For debugging purposes, we can log events to the console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Analytics Event]: ${eventName}`, eventParams || '');
  }
  if (analytics) {
    try {
      firebaseLogEvent(analytics, eventName, eventParams);
    } catch (e) {
      // Ignore analytics logging failures in unsupported environments
    }
  }
};